"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const businessAddressSlice_1 = require("./businessAddressSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const input_1 = __importStar(require("../../../components/input/input"));
const utils_1 = require("../../../utils/utils");
const states_1 = require("../../../utils/states");
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const choices_1 = require("../../../utils/choices");
const analytics_1 = require("../../../utils/analytics/analytics");
const BusinessAddress = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { businessData } = (0, store_1.useAppSelector)((state) => {
        return {
            hasPersonalData: state.home.kyc.personal,
            businessData: state.home.business_data,
        };
    });
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [addressState, setAddress] = (0, react_1.useState)(businessData ? businessData.business_address.address : '');
    const [stateState, setState] = (0, react_1.useState)(businessData ? businessData.business_address.state : '');
    const [lgaState, setLga] = (0, react_1.useState)(businessData ? businessData.business_address.lga : '');
    const [dateMovedIntoAddress, setDateMoved] = (0, react_1.useState)(businessData ? (0, utils_1.displayDate)(businessData.business_address.business_date_moved_address) : '');
    const [officeStatus, setOfficeStatus] = (0, react_1.useState)(businessData ? businessData.business_address.business_office_status : '');
    const [numberOutlets, setNumberOutlets] = (0, react_1.useState)(businessData ? businessData.business_address.outlets_count : '');
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        const payload = {
            address: addressState.toString(),
            state: stateState,
            lga: lgaState,
            business_date_moved_address: (0, utils_1.databaseDateFormat)(dateMovedIntoAddress.toString()),
            business_office_status: officeStatus,
            outlets_count: numberOutlets.toString(),
        };
        const result = await dispatch((0, businessAddressSlice_1.submitBusinessAddress)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_business_address',
            status: 'submitted',
            location: 'screen_BusinessAddress',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_business_address',
                status: 'success',
                location: 'screen_BusinessAddress',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PROFILE_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_business_address',
                status: 'fail',
                location: 'screen_BusinessAddress',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, childrenTitle: "Business address", footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "businessAddress_save" }) },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Address", placeholder: "Address", setValue: setAddress, error: (0, utils_1.getError)('address', errors), value: addressState }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: (0, states_1.getStates)(), label: "State", value: stateState || '', setValue: setState, error: (0, utils_1.getError)('state', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: (0, states_1.getLga)(stateState), label: "Local government area", value: lgaState || '', setValue: setLga, error: (0, utils_1.getError)('lga', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "When did the company moved to this address?", setValue: setDateMoved, value: dateMovedIntoAddress, error: (0, utils_1.getError)('business_date_moved_address', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Office status", error: (0, utils_1.getError)('business_office_status', errors), setValue: setOfficeStatus, value: officeStatus, choices: choices_1.officeStatusChoices }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "Number of outlets", placeholder: "Number of outlets", setValue: setNumberOutlets, error: (0, utils_1.getError)('outlets_count', errors), value: numberOutlets })));
};
exports.default = BusinessAddress;
